module.exports = __webpack_public_path__ + "img/face-nauseated.c9e4d736.svg";